import {History} from "./History";
import {Load} from "./Load";

export class Basic
{
    static init()
    {
        Basic.base = document.body.dataset.base;
        Basic.lang = document.documentElement.lang;
        Basic.resizeTimer = 0;
        Basic.scrollTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
        Basic.main = document.getElementById('w--main');
        Basic.quotation = document.getElementById('w--footer--context');
        Basic.context = document.getElementById('w--context');
        Basic.v = {
        }
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',async e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                if((e.ctrlKey || e.metaKey) &&
                    el.closest('.w__module.mod--chapter'))
                {
                    el = el.closest('.w__module.mod--chapter');
                    el.open = !el.open;
                }
                else
                {
                    return false;
                }
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
                el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'load':
                        if(!Basic.ise)
                        {
                            e.preventDefault();
                            await Basic.load_content(el);
                        }
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
        });
    }

    static async load_content(el)
    {
        const r = await Load.fetch({
            f: 'load',
            url: el.href
        });
        Basic.main.innerHTML = r['html'];
        // noinspection JSValidateTypes
        Basic.quotation.innerHTML = r['quotation'];
        Basic.context.innerHTML = r['context'];
        document.body.className = r['bodyClass'];
        History.push_url(el.href, r['pageTitle']);

        const activeLis = document.body.querySelectorAll('.w__menu li.active')
        for(const activeLi of activeLis)
        {
            activeLi.classList.remove('active');
        }

        const li = el.closest('li');
        if(li)
        {
            li.classList.add('active');
            const subUl = li.closest('.mod--sub');
            if(subUl)
            {
                subUl.closest('li').classList.add('active');
            }
        }
    }

    static process_resize()
    {
    }

    static process_scroll()
    {
    }
}

